import { render, staticRenderFns } from "./HandlersListItem.vue?vue&type=template&id=6101373b&scoped=true&"
import script from "./HandlersListItem.vue?vue&type=script&lang=js&"
export * from "./HandlersListItem.vue?vue&type=script&lang=js&"
import style0 from "./HandlersListItem.vue?vue&type=style&index=0&id=6101373b&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6101373b",
  null
  
)

export default component.exports